import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs/Subscription';

import {SpinnerService} from 'services/spinner.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {Router} from '@angular/router';
import {IndividualTravelService} from 'services/calculator-items/individual-travel.service';
import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';

@Component({
    selector: 'tpc-individual-flights',
    templateUrl: './individual-flights.component.html',
    styleUrls: ['./individual-flights.component.css']
})
export class IndividualFlightsComponent implements OnInit, OnDestroy {
    private isFormSubmitted = false;
    private nextSub: Subscription;
    public flightForm: FormGroup;
    public searchData = [];
    public from = '';

    constructor(protected travelService: IndividualTravelService,
                protected fb: FormBuilder,
                protected footerService: FooterNavbarService,
                protected emissionService: EmissionService,
                protected router: Router,
                protected spinner: SpinnerService
    ) {
        this.spinner.show();
        this.travelService.getJSON().subscribe(
            response => {
                this.searchData = response;
                this.spinner.hide();
            }
        );

        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.flightForm.status === 'VALID' && !this.checkFromToEqual()) {
                this.next();
            }
        });

        this.createForm();
    }

    ngOnInit() {
    }

    private createForm(): void {
        this.flightForm = this.fb.group({
            isRoundTrip: [true, Validators.required ],
            from : ['', [Validators.required, Validators.minLength(2), Validators.maxLength(45)]],
            to : ['', [Validators.required, Validators.minLength(2), Validators.maxLength(45)]]
        });
    }

    dataFormatter(data: any): string {
        return `${data.name}(${data.iata}) ${data.city}`;
    }

    private next(): void {
        let from = this.getFV('from'),
            to = this.getFV('to'),
            isRoundTrip = this.getFV('isRoundTrip'),
            multiplier = isRoundTrip ? 2 : 1,
            params = {
                calculateBy: 'byItinerary',
                FromIata: from.iata,
                FromName: from.name,
                ToIata: to.iata,
                ToName: to.name,
                distanceUnit: 'mi',
                multiplier: multiplier
            },
            calculatorName = Constants.calculators.individual,
            categoryName = Constants.categories.individual.travel;
            console.log("Params are : " + calculatorName + " " + categoryName);

        if (this.checkIfNameExist(from) && this.checkIfNameExist(to)) {
            this.spinner.show();
            this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
                response => {
                    let input = response.body[0].input[0];

                    this.travelService.addToFlightList({
                        title: this.getTitleForFlightList(params.FromIata, params.ToIata),
                        emission: input.emmission,
                        emissionTrees: input.emissionTrees,
                        DollarAmtMonthly: input.DollarAmtMonthly,
                        DollarAmt: input.DollarAmt,
                        isRoundTrip: isRoundTrip
                    });
                    this.spinner.hide();
                    this.router.navigate(['/individual/travel/list']);
                }
            );
        }
    }

    getTitleForFlightList(from: string, to: string): string {
        return from + ' - ' + to;
    }

    checkError(param): boolean {
        return (this.flightForm.get(param).status === 'INVALID' ||
            !this.checkIfNameExist(this.getFV(param))) && this.isFormSubmitted;
    }

    checkFromToEqual(): boolean {
        return  this.isFormSubmitted &&
            !!this.getFV('from').name &&
            !!this.getFV('to').name &&
            this.getFV('from').name === this.getFV('to').name;
    }

    checkIfNameExist(param): boolean {
        return (typeof param === 'string' &&
            !!this.searchData.filter(el => el.name === param)[0]) ||
            (typeof param === 'object' && !!this.searchData.filter(el => el.name === param.name)[0]);
    }

    getFV(param): any {
        return this.flightForm.get(param).value;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-flights/individual-flights.component.ts